import React from 'react'
import DashboardRoute from "./dashboard/Dashboard.Route"

const PrivateRoute = () => {
    return [
        ...DashboardRoute(),
    ]
}

export default PrivateRoute